import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import { PutExperienceStatus } from "@src/store/slices/experiences/types";

interface PutExperienceStatusViewProps {
  status: PutExperienceStatus;
}

export const PutExperienceStatusView = ({
  status,
}: PutExperienceStatusViewProps) => {
  return (
    <Grid
      container
      alignItems={"center"}
      justifyContent={"center"}
      direction={"column"}
      rowSpacing={2}
      width={"100%"}
    >
      <Grid>
        <IgTypography
          sx={{
            visibility: status.progress !== undefined ? "visible" : "hidden",
          }}
        >
          {status.progress !== undefined
            ? `${Math.round(status.progress)}%`
            : "100%"}
        </IgTypography>
      </Grid>
      <Grid
        id={"linearProgress"}
        sx={{ width: "100%", display: "flex", justifyContent: "center" }}
      >
        <LinearProgress
          variant={
            status.progress != undefined ? "determinate" : "indeterminate"
          }
          value={status.progress ?? 10}
          sx={{
            marginBottom: "10px",
            width: "25%",
            borderRadius: "0px",
            // visibility: status.progress !== undefined ? "visible" : "hidden",
          }}
        />
      </Grid>
      <Grid>
        <IgTypography>{status.message}</IgTypography>
      </Grid>
    </Grid>
  );
};
